{
  "name": "roundtablecxo",
  "versionDisplay": "02-June-2025 | v1.1.30 (001)",
  "version": "1.1.30",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:timestamp": "ng build && node post-build.js",
    "build:prod": "ng build --configuration production && node post-build.js && node inject-ga.js production",
    "build:dev": "ng build --configuration development && node post-build.js && node inject-ga.js dev",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "update-version": "node src/app/versioning-setup/scripts/updateVersion.js",
    "update-version:patch": "node src/app/versioning-setup/scripts/updateVersion.js patch",
    "update-version:minor": "node src/app/versioning-setup/scripts/updateVersion.js minor",
    "update-version:major": "node src/app/versioning-setup/scripts/updateVersion.js major"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.7",
    "@angular/common": "^19.1.0",
    "@angular/compiler": "^19.1.0",
    "@angular/core": "^19.1.0",
    "@angular/forms": "^19.1.0",
    "@angular/platform-browser": "^19.1.0",
    "@angular/platform-browser-dynamic": "^19.1.0",
    "@angular/router": "^19.1.0",
    "bootstrap": "^5.3.5",
    "boxicons": "^2.1.4",
    "jquery": "^3.7.1",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.6",
    "@angular/cli": "^19.1.6",
    "@angular/compiler-cli": "^19.1.0",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.7.2"
  }
}